import { useState } from "react";
import { ScrollArea } from "@volca/ui/components/ui/scroll-area";
import { AttachmentPreview } from "@/payroll/editor/editor-documents/attachment-preview";
import { AttachmentTile } from "@/payroll/editor/editor-documents/attachment-tile";
import { messageAttachment } from "@/payroll/editor/editor-documents/enrich-attachments";
import type { DraftMessageAttachment } from "@/payroll/editor/types";

export const MessageAttachments = ({
  files,
}: {
  files: DraftMessageAttachment[];
}) => {
  const [previewId, setPreviewId] = useState<string>();
  const attachments = files.map(messageAttachment);
  return (
    <>
      <ScrollArea horizontal className="max-w-full min-w-0">
        <ul aria-label="Message files" className="flex gap-2 pb-2">
          {attachments.map((file) => (
            <AttachmentTile
              key={file.id}
              file={file}
              onInspect={() => setPreviewId(file.id)}
            />
          ))}
        </ul>
      </ScrollArea>
      <AttachmentPreview
        file={attachments.find((file) => file.id === previewId)}
        onClose={() => setPreviewId(undefined)}
      />
    </>
  );
};
